<ng-container *ngIf="isInitComponent$(); else loader">
    <ng-container *ngIf="hasActivatedReportLite$()">
        <ng-container *ngTemplateOutlet="toolBenchmarkLite"></ng-container>
    </ng-container>
    <ng-container *ngTemplateOutlet="toolBenchmark"></ng-container>
</ng-container>
<ng-template #toolBenchmarkLite>
    <mat-card class="card-benchmark mat-elevation- p--lg-24 p--8 bg-sky">
        <mat-card-header class="d-flex flex-column flex-lg-row">
            <div class="col col-lg-6">
                <mat-card-title class="text-dark">
                    <div>Benchmark Lite </div>
                    <!-- <small class="text-muted mr--8">{{reportLiteCount$()}} di {{reportLiteCountLimit}} <span > - hai ancora {{ reportLiteCountLimit - reportLiteCount$() }} Benchmark Lite</span></small> -->
                </mat-card-title>
                <mat-card-subtitle>
                    Ottieni informazioni su aziende che osservi
                </mat-card-subtitle>
                <mat-card-subtitle>
                    Puoi richiederne ancora <b>{{ reportLiteCountLimit - reportLiteCount$() }}</b>
                </mat-card-subtitle>
            </div>
            <div class="col-12 col-lg-6 form-reports fw mb--8 mb--lg-16">
                <ng-container *ngIf="true">
                    <mat-form-field appearance="outline">
                        <mat-label>{{'Nuovo Benchmark Lite' | translate}}</mat-label>
                        <input  matInput
                            [formControl]="benchmarkLiteVatNumber" (paste)="managePaste($event,benchmarkLiteVatNumber)"
                            [errorStateMatcher]="matcher"
                            placeholder="Inserisci la partita iva">

                        <mat-error *ngIf="benchmarkLiteVatNumber.hasError('required')">
                            Inserisci una partita IVA valida
                        </mat-error>
                        <mat-error *ngIf="benchmarkLiteVatNumber.hasError('pattern')">
                            La partita IVA non è valida.
                        </mat-error>
                        <mat-icon *ngIf="benchmarkLiteVatNumber.valid" matPrefix color="success">check_circle_outline</mat-icon>
                        <mat-hint class="text-dark">Inserisci una partita IVA valida in formato Italiano senza il prefisso 'IT' e composta di 11 cifre</mat-hint>
                        <button [disabled]="benchmarkLiteVatNumber.invalid"
                            mat-flat-button color=primary class="mr--8" matSuffix (click)="addCompanyReport(true)"
                            [attr.aria-label]="'new report'">
                            <span class="hide show-lg">{{ 'Ottieni Benchmark Lite' | translate}}</span><span
                                class="show hide-lg"><span class="di di-add"></span></span>
                        </button>
                    </mat-form-field>
                </ng-container>
            </div>
        </mat-card-header>
        <mat-card-content class="pl--lg-24 pr--lg-24 pl--16 pr--16 text-dark">
            <ng-container *ngTemplateOutlet="tableBenchmark; context: { data: dataLiteSource$() }"></ng-container>
        </mat-card-content>
        
       
    </mat-card>
</ng-template>
<ng-template #toolBenchmark>
    <ng-container *ngIf="reportCount$() || hasActivatedReport$(); else promoteBenchmark">
        <mat-card class="card-benchmark mat-elevation- p--lg-24 p--8">
            <mat-card-header class="d-flex flex-column flex-lg-row">
                <div class="col col-lg-6">
                <mat-card-title>
                    Benchmark personalizzato
                </mat-card-title>
                <mat-card-subtitle>
                    Scopri di pi&ugrave; su aziende competitor, fornitori o clienti
                </mat-card-subtitle>
                <mat-card-subtitle>
                    <ng-container *ngIf="reportCount$() < reportCountLimit; else completedReports">
                    Puoi richiederne ancora <b>{{ reportCountLimit - reportCount$() }}</b>
                    </ng-container>
                    <ng-template #completedReports>
                    Hai esaurito i Benchmark.<a [routerLink]="['../', 'product','report-digitale']" class="text-primary" > {{ 'Acquistane altri' | translate }}</a>
                    </ng-template>
                     <!-- di {{ reportCountLimit }} -->
                </mat-card-subtitle>
            </div>
                <div class="col-12 col-lg-6 form-reports fw mb--8 mb--lg-16">
                    <ng-container *ngIf="reportCount$() < reportCountLimit;">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'Nuovo Benchmark' | translate}}</mat-label>
                            <input  matInput
                                [formControl]="benchmarkVatNumber" (paste)="managePaste($event,benchmarkVatNumber)"
                                [errorStateMatcher]="matcher"
                                placeholder="Inserisci la partita iva">

                            <mat-error *ngIf="benchmarkVatNumber.hasError('required')">
                                Inserisci una partita IVA valida
                            </mat-error>
                            <mat-error *ngIf="benchmarkVatNumber.hasError('pattern')">
                                La partita IVA non è valida.
                            </mat-error>
                            <mat-icon *ngIf="benchmarkVatNumber.valid" matPrefix color="success">check_circle_outline</mat-icon>
                            <mat-hint>Inserisci una partita IVA valida in formato Italiano senza il prefisso 'IT' e composta di 11 cifre</mat-hint>
                            <button [disabled]="benchmarkVatNumber.invalid"
                                mat-flat-button color=primary class="mr--8" matSuffix (click)="addCompanyReport()"
                                [attr.aria-label]="'new report'">
                                <span class="hide show-lg">{{ 'Ottieni Benchmark' | translate}}</span><span
                                    class="show hide-lg"><span class="di di-add"></span></span>
                            </button>
                        </mat-form-field>
                    </ng-container>
                </div>
            
            </mat-card-header>
            <mat-card-content class="pl--lg-24 pr--lg-24 pl--16 pr--16">
                <ng-container *ngTemplateOutlet="tableBenchmark; context: { data: dataSource }"></ng-container>
                    <mat-divider class="mt--48"></mat-divider>
                    <mat-card-actions class="pt--lg-24 pb--lg-24 pt--8 pb--8" >
                        <ng-container *ngTemplateOutlet="promoteNewBenchmark"></ng-container>
                    </mat-card-actions>
            </mat-card-content>
        </mat-card>
    </ng-container>
</ng-template>

<ng-template #tableBenchmark let-datasource = "data">

    <table mat-table [dataSource]="datasource"
                    class="mat-elevation-z0 mat-table-responsive style-3">
                    <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

                    <ng-container matColumnDef="idx">
                        <th mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let element; let i = index;">
                            <span class="mobile-label">#</span>
                            {{i + 1}}
                        </td>
                    </ng-container>        
                    <!-- businessName Column -->
                    <ng-container matColumnDef="businessName">
                        <th mat-header-cell *matHeaderCellDef>{{ 'label.company' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mobile-label">{{ 'label.company' | translate }}</span>
                            {{element.businessName}}
                        </td>
                    </ng-container>

                    <!-- vatNumber Column -->
                    <ng-container matColumnDef="vatNumber">
                        <th mat-header-cell *matHeaderCellDef>{{ 'label.vatNumber' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mobile-label">{{ 'label.vatNumber' | translate }}</span>
                            {{element.vatNumber}}
                        </td>
                    </ng-container>

                    <!-- requestDate Column -->
                    <ng-container matColumnDef="requestDate">
                        <th mat-header-cell *matHeaderCellDef>{{ 'label.requestDate' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mobile-label">{{ 'label.requestDate' | translate }}</span>
                            {{element.requestDate | date : 'dd/MM/yyyy'}}
                        </td>
                    </ng-container>

                    <!-- action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>{{ 'label.benchmark' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="mobile-label">{{ 'label.benchmark' | translate }}</span>
                            <ng-container *ngIf="element.status;" [ngSwitch]="element.status">
                                <ng-container *ngSwitchCase="'completed'">
                                    <button mat-stroked-button 
                                    (click)="getReport(element.vatNumber)"
                                    [downloadAnimation]="isDownloadingReport(element.vatNumber)"
                                    color="primary">
                                    <ng-container *ngIf="isDownloadingReport(element.vatNumber); else notDownloading">
                                        {{ 'Downloading...' | translate }}
                                    </ng-container>
                                    <ng-template #notDownloading>
                                        <ng-container *ngIf="mobileQuery.matches; else notMobile">
                                        {{ 'Download Benchmark' | translate }}
                                        </ng-container>
                                        <ng-template #notMobile>
                                        {{ 'Benchmark' | translate }}
                                        </ng-template>
                                    </ng-template> 
                                    <mat-icon *ngIf="!isDownloadingReport(element.vatNumber)">download</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-container *ngSwitchCase="'expired'">
                                    <button mat-stroked-button color="warn"
                                        (click)="getNewReport(element.vatNumber)" matBadgeColor="warn"
                                        class="button-retry-report" matBadge="!"
                                        matTooltip="{{ 'tooltip_benchmark_expired' | translate}}">
                                        {{ 'Ripeti la richiesta' | translate }}
                                        <mat-icon>reply</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-container *ngSwitchCase="'error'">
                                    <button mat-stroked-button color="warn"
                                        (click)="getNewReport(element.vatNumber)" matBadgeColor="warn"
                                        class="button-retry-report" matBadge="!"
                                        matTooltip="{{ 'tooltip_benchmark_error' | translate}}">
                                        {{ 'Ripeti la richiesta' | translate }}
                                        <mat-icon>reply</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-container *ngSwitchCase="'unavailable'">
                                    <div class="text-danger">{{ 'tooltip_benchmark_unabailable' | translate }}</div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <button mat-flat-button disabled>
                                        {{ 'Generating the customized Benchmark' | translate }}
                                        <span class="opportunity-state" [ngClass]="element.status"
                                            matTooltip="Generazione in corso">
                                            <mat-icon
                                                class="animation-rotation mat-warning">hourglass_bottom</mat-icon>
                                        </span>
                                    </button>
                                </ng-container>
                            </ng-container>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
                </table>
</ng-template>
<ng-template #promoteNewBenchmark>
    <div class="d-flex align-items-center gap-16">
        <div class="text-primary mr--8 ">{{ 'Conosci i tuoi competitor ? Acquista più Benchmark personalizzati per analizzare la concorrenza' | translate }}</div> <button mat-stroked-button color="primary" (click)="getMoreReport()"> {{ 'Scopri come' | translate }}</button>
    </div>
</ng-template>


<ng-template #promoteBenchmark>

    <div class="row">

        <div class="col-12 col-lg-6">
            <h4 class="text-primary">Conosci davvero la tua azienda?</h4>
            <h1 class="h1">Ottieni il Benchmark personalizzato e massimizza i tuoi profitti</h1>
            <div class="text-default">Migliora la tua azienda grazie all'Intelligenza Artificiale. Delfi.ai puo'
                aiutarti ad estrarre automaticamente informazini finanziarie relative alla tua azienda, di confontarle
                con i tuoi competitor e di fornirti una analisi dettagliata sulle tue criticità, i punti di forza e di
                come ottimizzare le potenzialità della tua azienda.</div>
            <button mat-stroked-button (click)="getMoreReport()" class="mt--24" color="primary"> {{ 'Scopri di più' |
                translate }}</button>
        </div>
        <div class="col-12 col-lg-6">
            <img [ngSrc]="'/images/background/benchmark-devices.webp'" width="300" height="300" alt="Benchmark Devices"
                class="img-responsive rounded" />
        </div>

    </div>
</ng-template>

<ng-template #loader>
    <ngx-mare-skeleton [grid]="'2x1'" [template]="['title','subtitle','content']"></ngx-mare-skeleton>
</ng-template>